<template>
    <div class="rate-box">
        <el-autocomplete class="inline-input"
                         v-model="queryParams.coinType"
                         :fetch-suggestions="querySearch"
                         placeholder="请输入币种"
                         @select="handleSelect"
                         @keyup.native.enter="handleSearch">
            <i class="el-icon-close el-input__icon" slot="suffix"
               @click="cleanSearchCoin" style="cursor:pointer;">
            </i>
        </el-autocomplete>
        <el-button type="primary" @click="searchRate">搜索</el-button>
        <div class="preview-opration">
            <el-button style="margin-left: 30px" icon="el-icon-plus" type="danger" @click="openCreateRateDialog">新增
            </el-button>
        </div>
        <div class="rate-list">
            <el-table class="rate-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="rateList" :row-key="() => Math.random()">
                <el-table-column prop="coinType" label="币种类型"></el-table-column>
                <el-table-column prop="yearRate" label="利率" show-overflow-tooltip></el-table-column>
                <el-table-column prop="rateDate" label="时间" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.rateDate | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="danger" @click="updataRate(scope.row)">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%" @close="clearData"
                   :close-on-click-modal="false">
            <el-form label-width="300px" :model="rateData" :rules="pathRules" ref="rateForm">
                <el-form-item label="币种：" prop="coinType" style="padding-top: 20px" v-if="currOpration==1">
                    <el-input v-model="rateData.coinType" placeholder="币种" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="时间：" prop="rateDate" style="padding-top: 20px">
                    <el-date-picker v-model="rateData.rateDate" value-format="timestamp" type="datetime"
                                    style="width: 500px" placeholder="选择日期时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="利率：" prop="rate" style="padding-top: 20px">
                    <el-input v-model="rateData.rate" placeholder="利率" style="width: 500px"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="addRate">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: 'Rate',
        data() {
            return {
                rateList: [], //数据列表
                total: 0, //总条数
                queryParams: { //查询参数
                    page: 1,
                    size: 10,
                    coinType: "",
                },
                rateData: {id: "", coinType: "", rateDate: "", rate: ""},
                coinTypes: [],
                dialogVisible: false,
                dialogTitle: "",
                loading: false,
                currOpration: 1,  //1-新增，2-修改
                pathRules: {
                    "coinType": [{required: true, message: "请输入挖矿币种"}],
                    "rateDate": [{required: true, message: "请选择时间"}],
                    "rate": [{required: true, message: "请输入利率"}]
                },
            }
        },
        methods: {
            getRateList(query) {
                api.getUserMiningRateList(query).then(({data}) => {
                    this.rateList = data.list;
                    this.total = data.totalCount;
                });
            },
            searchRate(){
                this.queryParams.page = 1;
                this.getRateList(this.queryParams);
            },
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            openCreateRateDialog() {
                this.currOpration = 1;
                this.dialogTitle = "新增";
                this.rateData = {id: "", coinType: "", rateDate: "", rate: ""};
                this.dialogVisible = true;
            },
            updataRate(row) {
                this.currOpration = 2;
                this.dialogTitle = "修改";
                this.rateData = {id: row.id, coinType: row.coinType, rateDate: row.rateDate, rate: row.yearRate};
                this.dialogVisible = true;
            },
            addRate() {
                this.$refs["rateForm"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        if (this.currOpration == 1) {
                            api.addUserMiningRate(this.rateData).then(({data}) => {
                                this.$message.success('操作成功!');
                                this.loading = false;
                                this.dialogVisible = false;
                                this.getRateList(this.queryParams);
                            });
                        } else {
                            api.updateUserMiningRate(this.rateData).then(({data}) => {
                                this.$message.success('操作成功!');
                                this.loading = false;
                                this.dialogVisible = false;
                                this.getRateList(this.queryParams);
                            });
                        }
                    }
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getRateList(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getRateList(this.queryParams);
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.queryParams.coinType = '';
            },
            handleSearch() {
                this.queryParams.page = 1;
                this.getRateList(this.queryParams);
            },
            handleSelect() {
            },
            clearData() {
                this.loading = false;
                this.currOpration = 1;
                this.dialogTitle = "";
                this.rateData = {id: "", coinType: "", rateDate: "", rate: ""};
            }
        },
        created() {
            this.getAllSupportCoin();
            this.getRateList(this.queryParams);
        }
    };
</script>

<style lang="less" scoped>
    .rate-box {
        .preview-opration {
            float: right;
        }

        .rate-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .rate-table {
                margin-top: 30px;
            }
        }
    }
</style>
